<template>
  <div class="text-left">
    <span class="star-item h7" @click="$emit('setPrice',priceItem)" v-for="(priceItem,index) in priceConditionLists" :key="index">{{priceItem.name}}</span>
  </div>
</template>

<script>
  import {mapState} from 'vuex'

    export default {
        name: 'ChoosePrice',
      data() {
        return {
          priceConditionLists:[{id:0,name:'不限'},{id:1,name:'150元以内'},{id:2,name:'151-300元'},{id:3,name:'301-600元'},{id:4,name:'601-1000元'},{id:5,name:'1000元以上'}],
        }
      },
      computed: {
        ...mapState(['userLoginMessage']),
      }
    }
</script>

<style lang="scss" scoped>
  .star-item {
    color: #000;
    display: inline-block;
    width:90px;
    padding-left: 5px;
    margin-bottom: 10px;
    cursor: pointer;
    &:hover{
      color: red;
    }
  }
</style>
